<template>
  <span class="gd-pill" :class="[`gd-pill-${status}`, {'gd-pill-sm': size === 'sm'}]">
    <fa-icon :icon="['fal', icon]"/>{{ label }}
  </span>
</template>

<script>
import { getIcon, getLabel } from '@/data/billing-account-statuses';

export default {
  props: {
    status: {
      type: String,
      default: 'open',
    },
    batchNumber: {
      type: [String, Number],
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'xs',
    },
  },
  computed: {
    icon() {
      return getIcon(this.status);
    },
    label() {
      return this.text || getLabel(this.status, this.batchNumber);
    },
  },
};
</script>
